import { useState } from 'react'
import { FiCheck, FiX } from 'react-icons/fi'

import { Button } from '~/components/Buttons'
import { ModalConfirmations } from '~/components/CampaignReviewModal'
import useModal from '~/hooks/useModal'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'
import { useReviewAdActions } from '~/modules/retailMedia/hooks/useReviewAdActions'

const ReviewActions: React.FC<{ adId: string }> = ({ adId }) => {
  const { t } = useAPPTranslation()

  const [contentModal, setContentModal] = useState<ContentModal | null>(null)
  const [Modal, showConfirmationModal, toggleConfirmationModal] = useModal()

  const { approveBanner, rejectBanner, handleApprove, handleReject } =
    useReviewAdActions({
      adId,
      onRejectSuccess: toggleConfirmationModal
    })

  const handleOpenRejectModal = () => {
    setContentModal({
      titleModal: t('rm:reviewAd.reject.title.modal'),
      labelMessage: t('rm:reviewAd.reject.label.message'),
      subtitletLabelMessage: t('rm:reviewAd.reject.subtitle.label.message'),
      textButton: t('rm:button.Reject'),
      templateButton: 'critical',
      status: 'rejected',
      action: 'review',
      noteIsRequired: true,
      hasCancelButton: true
    })

    toggleConfirmationModal()
  }

  const handleSubmitReject = async ({ note }: { note: string }) => {
    handleReject(note)
  }

  return (
    <>
      <div className="d-flex gap-2 ms-auto">
        <Button
          template="critical"
          size="xsmall"
          // customWidth="auto"
          onClick={handleOpenRejectModal}
          loading={rejectBanner.isPending}
          text={t('rm:button.Reject')}
          iconLeft={<FiX />}
        />

        <Button
          template="primary"
          size="xsmall"
          // customWidth="auto"
          onClick={handleApprove}
          loading={approveBanner.isPending}
          text={t('rm:button.Approve')}
          iconLeft={<FiCheck />}
        />
      </div>

      <ModalConfirmations
        Modal={Modal}
        showConfirmationModal={showConfirmationModal}
        handleSubmit={handleSubmitReject}
        toggleConfirmationModal={toggleConfirmationModal}
        contentModal={contentModal}
      />
    </>
  )
}

export default ReviewActions
